import React, { createContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser]       = useState(null);
    const [permisos, setPermisos] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadUser = useCallback(async () => {
        const token = localStorage.getItem('accessToken');
        if (!token) { setLoading(false); return; }
        try {
            const { data } = await api.get('/users/profile');
            setUser(data);
            setPermisos(data.permisos || []);
        } catch {
            localStorage.removeItem('accessToken');
            setUser(null);
            setPermisos([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { loadUser(); }, [loadUser]);

    const login = async (email, password) => {
        const { data } = await api.post('/auth/login', { email, password });
        localStorage.setItem('accessToken', data.accessToken);
        // Cargar perfil completo con permisos en una sola llamada
        const profile = await api.get('/users/profile');
        setUser(profile.data);
        setPermisos(profile.data.permisos || []);
        return profile.data;
    };

    const logout = async () => {
        try { await api.post('/auth/logout'); } finally {
            localStorage.removeItem('accessToken');
            setUser(null);
            setPermisos([]);
        }
    };

    const updateUser = (newData) => setUser(prev => ({ ...prev, ...newData }));

    const can = (modulo, accion) => {
        if (!user) return false;
        if (user.role_slug === 'superadmin' || user.role_slug === 'admin') return true;
        return permisos.some(p => p.modulo === modulo && p.accion === accion);
    };

    return (
        <AuthContext.Provider value={{ user, permisos, loading, login, logout, updateUser, loadUser, can }}>
            {children}
        </AuthContext.Provider>
    );
};
